import React from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Tooltip, Button } from 'antd';
import {
    EditOutlined,
    SaveOutlined,
    CloseOutlined,
    DeleteOutlined,  // Importamos el ícono de eliminar
} from '@ant-design/icons';

export interface DataGridInstance {
    editRow: (rowIndex: number) => void;
    saveEditData: () => void;
    cancelEditData: () => void;
    clearFilter: () => void;

    element(): HTMLElement;
}


interface EditColumnProps {
    gridRef: React.RefObject<{ instance: () => DataGridInstance }>;
    width?: number;
    showSave?: boolean;
    showCancel?: boolean;
    showEdit?: boolean;
    showDelete?: boolean;
    onDelete?: (rowIndex: number) => void;
    isDisabled?: boolean;
}

export const EditColumn: React.FunctionComponent<EditColumnProps> = (props) => {
    const {
        gridRef,
        width = 120,
        showSave = true,
        showCancel = true,
        showEdit = true,
        showDelete = false,  // Por defecto no mostrar el botón de eliminar
        onDelete,
        isDisabled = false,
    } = props;
    // Uso de useCallback para evitar recrear las funciones en cada renderizado
    const handleEdit = React.useCallback((rowIndex: number) => {
        const grid = gridRef?.current?.instance();
        grid?.editRow(rowIndex);
    }, [gridRef]);

    const handleSave = React.useCallback(() => {
        const grid = gridRef?.current?.instance();
        grid?.saveEditData();
    }, [gridRef]);

    const handleCancel = React.useCallback(() => {
        const grid = gridRef?.current?.instance();
        grid?.cancelEditData();
    }, [gridRef]);

    const handleDelete = React.useCallback((rowIndex: number) => {
        if (onDelete) {
            onDelete(rowIndex);  // Llamamos a la función de eliminación pasada por props
        }
    }, [onDelete]);

    return (
        <Column
            caption="Acciones"
            width={width}
            allowEditing={false}
            cellRender={(cellData) => {
                const row = cellData?.row;
                const rowIndex = row?.rowIndex;

                if (!row) return null;

                const isEditing = row.isEditing;

                return (
                    <div style={{ display: 'flex', gap: 8 }}>
                        {isEditing ? (
                            <>
                                {showSave && (
                                    <Tooltip title="Guardar">
                                        <Button
                                            type="link"
                                            icon={<SaveOutlined />}
                                            size="small"
                                            onClick={handleSave}
                                            disabled={isDisabled}
                                        />
                                    </Tooltip>
                                )}
                                {showCancel && (
                                    <Tooltip title="Cancelar">
                                        <Button
                                            type="link"
                                            icon={<CloseOutlined />}
                                            size="small"
                                            onClick={handleCancel}
                                            disabled={isDisabled}
                                        />
                                    </Tooltip>
                                )}
                            </>
                        ) : (
                            <>
                                {showEdit && (
                                    <Tooltip title="Editar">
                                        <Button
                                            type="link"
                                            icon={<EditOutlined />}
                                            size="small"
                                            onClick={() => handleEdit(rowIndex)}
                                            disabled={isDisabled}
                                        />
                                    </Tooltip>
                                )}
                                {showDelete && (
                                    <Tooltip title="Eliminar">
                                        <Button
                                            type="link"
                                            icon={<DeleteOutlined />}
                                            size="small"
                                            onClick={() => handleDelete(rowIndex)}
                                            disabled={isDisabled}
                                        />
                                    </Tooltip>
                                )}
                            </>
                        )}
                    </div>
                );
            }}
        />
    );
};
